import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a2d] py-12 px-4" data-id="element-279">
      <div className="max-w-5xl mx-auto" data-id="element-280">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-281">
          <div data-id="element-282">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-283">
              +300
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-284">
              profes confían
            </div>
          </div>
          <div data-id="element-285">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-286">
              6+6
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-287">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-288">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-289">
              4.9/5
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-290">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-291">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-292">🇦🇷</div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-293">
              Todo el país
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-294">
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-295">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-296">
              MR
            </div>
            <div data-id="element-297">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-298">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-299">
                "Organicé todo el año en una tarde. Ahora tengo cada clase
                pensada y secuenciada para todos mis grupos — desde los chicos
                de 6 años hasta los adultos de 3ra categoría."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-300">
                — Martín R., Buenos Aires | Profesor de Tenis en Club de Barrio
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-301">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-302">
              CS
            </div>
            <div data-id="element-303">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-304">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-305">
                "Las 48 semanas por nivel con progresión real. Mis alumnos
                juniors subieron de categoría por primera vez en años. Los
                drills del Tomo 5 hacen toda la diferencia."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-306">
                — Carolina S., Rosario | Entrenadora en Academia Privada
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-307">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-308">
              DV
            </div>
            <div data-id="element-309">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-310">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-311">
                "Adapto el mismo ejercicio a 4 niveles distintos en 5 minutos.
                Antes me llevaba horas inventar. Ahora abro el PDF y en 3
                minutos tengo todo listo."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-312">
                — Diego V., Córdoba | Profesor de Tenis Independiente
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}